/**
 * Tiny module-level coordinator between the AiGenerateDialog (which shows the
 * live timer + result while it's open) and the app-wide AiGenerationListener
 * (which toasts otherwise). While a dialog is open and watching a run, the
 * global toast is suppressed so the user doesn't get both the in-dialog summary
 * AND a toast. The socket work is the same either way — this only decides which
 * surface reports the result. A counter (not a boolean) tolerates the edge of
 * more than one dialog instance mounting.
 */
let watchers = 0

export const addWatcher = () => {
  watchers += 1
}

export const removeWatcher = () => {
  watchers = Math.max(0, watchers - 1)
}

export const hasWatcher = () => watchers > 0
